/**
 * AI CONTEXT
 * Purpose: attendance summary mini-block for a session inside timeline tooltip.
 * Inputs: session + AdminViewContext exception/student maps.
 * Used by: SessionStripeTooltip.
 * Refactor: memoize summary calculation for stable tooltip performance.
 */
import { useAdminViewContext } from "#contexts/AdminViewContextProvider"
import { ClassSessionConstructor } from "#customTypes/composedTypes/classSessionTypes"
import { Uuid } from "#customTypes/globalTypes"
import { getSessionAttendanceSummary } from "#utils/classHelpers"

import TooltipBlock from "./TooltipBlock"

type SessionAttendanceDetailsInput = {
  id: Uuid
  session: ClassSessionConstructor
} | null

const SessionAttendanceDetails = ({
  session,
}: {
  session: SessionAttendanceDetailsInput
}) => {
  const { exceptionDataBySessionId, studentsById } = useAdminViewContext()
  const studentsByExceptionType = session?.id
    ? exceptionDataBySessionId[session?.id]
    : {}

  if (!session?.session) return null

  const attendanceSummary = getSessionAttendanceSummary(
    session.session,
    studentsById,
    studentsByExceptionType
  )

  return (
    <TooltipBlock title="Attendance summary">
      <div>Present: {attendanceSummary.PRESENT}</div>
      <div>Tardy: {attendanceSummary.TARDY}</div>
      <div>Absent: {attendanceSummary.ABSENT}</div>
      <div>Unknown: {attendanceSummary.ENROLLED}</div>
    </TooltipBlock>
  )
}

export default SessionAttendanceDetails
